import axios from "axios";
import globals from "@/config/globals";

export default {
  index(filters = {}) {
    return axios.get(`${globals.getApiHost()}/enums`);
  },
}
